import Vue from 'vue';
import Router from 'vue-router';
// const _import = (url) => import(`./views/${url}`);

Vue.use(Router);

// PLM内嵌页
const plmTitles = [
    '系统通知', '样品确认单', '样品确认状态调整', '送样申请单', '送样供方资料录入', '零部件委托测试单', '测试报告', '胶版菲林资料', '胶板菲林',
    '待整改问题项', '文档管理功能', '图纸#企标查询', 'MCO', 'ECR', 'ECO', '供应商确认', '手板变更申请', '手板状态查询', '驳回再确认手板',
    '供应商送货清单', '待上传证书', '已上传证书的认证', '集采图纸查询', '审计管理', '长周期检测项目提交'
];
let plmRoutes = [];
plmTitles.forEach((item, index) => {
    plmRoutes.push(
        {
            path: `/UrlInstanceView/${index + 1}`,
            name: `UrlInstanceView${index + 1}`,
            component: () => import('./views/sys/plmIframe.vue'),
            meta: {
                title: `route.plm${index}`,
                tagsView: '/UrlInstanceView',
                authority: '/UrlInstanceView',
            },
        },
    );
});
export const routeConfig = [{
  path: '/',
  component: () => import('./views/homeSwitch.vue'),
  redirect: '/gsc',
  children: [{
    path: '/gsc',
    name: 'gsc',
    component: () => import('./views/GscSwitch.vue'),
    meta: {
      title: 'route.index',
      tagsView: 'gsc',
      authority: '/gsc'
    }
  },
  {
    path: '/purchaseOrder/purchaseOrderList',
    name: 'PurchaseOrderList', // 采购订单查询
    component: () => import('./views/purchaseOrder/PurchaseOrderList'),
    meta: {
        title: 'route.purchaseOrderSearch',
        tagsView: '/purchaseOrder/purchaseOrderList',
        authority: '/purchaseOrder/purchaseOrderList'
    }
  },
  {
    path: '/financialAccounting/rcvReturnSearch',
    name: 'rcvReturnSearch', // 接收退货明细查询
    component: () => import('./views/financialAccounting/rcvReturnSearch'),
    meta: {
          title: 'route.rcvReturnSearch',
          tagsView: '/financialAccounting/rcvReturnSearch',
          authority: '/financialAccounting/rcvReturnSearch'
      }
  },
  {
      path: '/supplier/SupplyRatioQuery',
      name: 'SupplyRatioQuery',
      component: () => import('./views/supplier/SupplyRatioQuery'),
      meta: {
          title: 'route.SupplyRatioQuery', // 供货比例查询
          tagsView: '/supplier/SupplyRatioQuery',
          authority: '/supplier/SupplyRatioQuery'
      }
  },
  {
    path: '/performance/performanceQueryView',
    name: 'PerformanceQueryView',
    component: () => import('./views/performance/PerformanceQueryView'),
    meta: {
        title: 'route.performanceQueryView', // 绩效结果查询
        tagsView: '/performance/performanceQueryView',
        authority: '/performance/PerformanceQueryView'
    }
  },
  {
    path: '/performance/equipmentCapacityMaintenance',
    name: 'equipmentCapacityMaintenance',
    component: () => import('./views/performance/equipmentCapacityMaintenance'),
    meta: {
        title: 'route.equipmentCapacityMaintenance', // 设备产能维护
        tagsView: '/performance/equipmentCapacityMaintenance',
        authority: '/performance/equipmentCapacityMaintenance'
    }
  },
  {
    path: '/performance/performanceQueryDetail',
    name: 'PerformanceQueryDetail',
    component: () => import('./views/performance/PerformanceQueryDetail'),
    meta: {
        title: 'route.performanceQueryDetail',
        tagsView: '/performance/PerformanceQueryDetail',
        noTagsView: true,
        authority: '/performance/PerformanceQueryDetail'
    }
  },
  {
      path: '/performance/performanceQueryTrend',
      name: 'PerformanceQueryTrend',
      component: () => import('./views/performance/PerformanceQueryTrend'),
      meta: {
          title: 'route.performanceQueryTrend',
          tagsView: '/performance/PerformanceQueryTrend',
          noTagsView: true,
          authority: '/performance/PerformanceQueryTrend'
      }
  },
  {
      path: '/performance/performanceQueryPoints',
      name: 'PerformanceQueryPoints',
      component: () => import('./views/performance/PerformanceQueryPoints'),
      meta: {
          title: 'route.performanceQueryPoints',
          tagsView: '/performance/PerformanceQueryPoints',
          noTagsView: true,
          authority: '/performance/PerformanceQueryPoints'
      }
  },
  {
    path: '/storeTool/StoreToolMgnView',
    name: 'storeToolMgnView',
    component: () => import('./views/storeTool/StoreToolMgnView'),
    meta: {
        title: 'route.StoreToolMgnView', // 库存录入
        tagsView: '/storeTool/StoreToolMgnView',
        authority: '/storeTool/StoreToolMgnView'
    }
},
{
    path: '/storeTool/queryStoreToolView',
    name: 'queryStoreToolView',
    component: () => import('./views/storeTool/QueryStoreToolView'),
    meta: {
        title: 'route.queryStoreToolView', // '库存查询',
        tagsView: '/storeTool/QueryStoreToolView',
        authority: '/storeTool/QueryStoreToolView'
    }
},
{
    path: '/storeTool/ApplyReceiveMgnView',
    name: 'ApplyReceiveMgnView',
    component: () => import('./views/storeTool/ApplyReceiveMgnView'),
    meta: {
        title: 'route.applyReceiveMgnView',
        tagsView: '/storeTool/ApplyReceiveMgnView',
        authority: '/storeTool/ApplyReceiveMgnView'
    }
},
{
    path: '/storeTool/ApplyReceiveApplyView',
    name: 'ApplyReceiveApplyView',
    component: () => import('./views/storeTool/ApplyReceiveApplyView'),
    meta: {
        title: 'route.ApplyReceiveApplyView',
        tagsView: '/storeTool/ApplyReceiveApplyView',
        authority: '/storeTool/ApplyReceiveApplyView'
    }
},
{
  path: '/priceQuotas/wholeSalePriceQuery',
  name: 'wholeSalePriceQuery',
  component: () => import('./views/priceQuotas/WholeSalePriceView'),
  meta: {
      title: 'route.wholeSalePriceView',
      tagsView: '/priceQuotas/WholeSalePriceView',
      authority: '/priceQuotas/WholeSalePriceView'
  }
},
{
  path: '/purchaseDistribution/deliveryNoticeConfirm',
  name: 'deliveryNoticeConfirm',
  component: () => import('./views/purchaseDistribution/deliveryNoticeConfirm'),
  meta: {
      title: 'deliveryNoticeConfirm.t45',
      tagsView: '/purchaseDistribution/deliveryNoticeConfirm',
      authority: '/purchaseDistribution/deliveryNoticeConfirm'
  }
},
{
  path: '/purchaseDistribution/createDeliveryOrderToInformView',
  name: 'createDeliveryOrderToInformView',
  component: () => import('./views/purchaseDistribution/createDeliveryOrderToInformView'),
  meta: {
      title: 'createDeliveryOrderToInformView.t50',
      tagsView: '/purchaseDistribution/createDeliveryOrderToInformView',
      authority: '/purchaseDistribution/createDeliveryOrderToInformView'
  }
},
{
  path: '/purchaseDistribution/createDeliveryOrderByOrder',
  name: 'createDeliveryOrderByOrder',
  component: () => import('./views/purchaseDistribution/createDeliveryOrderByOrder'),
  meta: {
      title: 'createDeliveryOrderByOrder.t40',
      tagsView: '/purchaseDistribution/createDeliveryOrderByOrder',
      authority: '/purchaseDistribution/createDeliveryOrderByOrder'
  }
},
{
  path: '/purchaseDistribution/DeliveryOrderQuery',
  name: 'DeliveryOrderQuery',
  component: () => import('./views/purchaseDistribution/DeliveryOrderQuery'),
  meta: {
      title: 'DeliveryOrderQuery.t47',
      tagsView: '/purchaseDistribution/DeliveryOrderQuery',
      authority: '/purchaseDistribution/DeliveryOrderQuery'
  }
},
{
  path: '/purchaseDistribution/createMaterialLabel',
  name: 'createMaterialLabel',
  component: () => import('./views/purchaseDistribution/createMaterialLabel'),
  meta: {
      title: 'createMaterialLabel.t1',
      tagsView: '/purchaseDistribution/createMaterialLabel',
      authority: '/purchaseDistribution/createMaterialLabel'
  }
},
{
  path: '/purchaseDistribution/deliveryNoticeDetailInquery',
  name: 'deliveryNoticeDetailInquery',
  component: () => import('./views/purchaseDistribution/deliveryNoticeDetailInquery'),
  meta: {
      title: 'deliveryNoticeDetailInquery.t1',
      tagsView: '/purchaseDistribution/deliveryNoticeDetailInquery',
      authority: '/purchaseDistribution/deliveryNoticeDetailInquery'
  }
},
{
  path: '/wonderful/:system/:routerLink', // 档案管理
  name: 'wonderful',
  props: true,
  component: () => import('./views/UrlInstanceRender'),
  meta: {
      title: 'menu.t1'
  }
},
{
  path: '/wonderful2/:system/:routerLink', // 通知公告
  name: 'wonderful2',
  props: true,
  component: () => import('./views/UrlInstanceRender'),
  meta: {
      title: 'menu.t2'
  }
},
{
  path: '/wonderful3/:system/:routerLink', // 价格审批
  name: 'wonderful3',
  props: true,
  component: () => import('./views/UrlInstanceRender'),
  meta: {
      title: 'menu.t3'
  }
},
{
  path: '/wonderful4/:system/:routerLink',
  name: 'wonderful4',
  props: true,
  component: () => import('./views/UrlInstanceRender'),
  meta: {
      title: 'menu.t4'
  }
},
{
  path: '/wonderful5/:system/:routerLink/:noticeHeaderId',
  name: 'wonderful5',
  props: true,
  component: () => import('./views/UrlInstanceRender'),
  meta: {
      title: 'menu.t2'
  }
},
{
  path: '/wonderful6/:system/:routerLink', // 创建补换货单
  name: 'wonderful6',
  props: true,
  component: () => import('./views/UrlInstanceRender'),
  meta: {
      title: 'menu.t6'
  }
},
{
  path: '/wonderful7/:system/:routerLink', // 打印补换货单
  name: 'wonderful7',
  props: true,
  component: () => import('./views/UrlInstanceRender'),
  meta: {
      title: 'menu.t7'
  }
},
{
  path: '/purchaseDistribution/importNoticeQuery',
  name: 'importNoticeQuery',
  component: () => import('./views/purchaseDistribution/importNoticeQuery'),
  meta: {
      title: 'importNoticeCommon.h1',
      tagsView: '/purchaseDistribution/importNoticeQuery',
      authority: '/purchaseDistribution/importNoticeQuery'
  }
},
{
  path: '/purchaseDistribution/importNoticeAdd',
  name: 'importNoticeAdd',
  component: () => import('./views/purchaseDistribution/importNoticeAdd'),
  meta: {
      title: 'importNoticeCommon.h2',
      tagsView: '/purchaseDistribution/importNoticeAdd',
      authority: '/purchaseDistribution/importNoticeAdd'
  }
},
{
  path: '/purchaseDistribution/importNoticeEdit',
  name: 'importNoticeEdit',
  component: () => import('./views/purchaseDistribution/importNoticeEdit'),
  meta: {
      title: 'importNoticeCommon.h3',
      tagsView: '/purchaseDistribution/importNoticeEdit',
      authority: '/purchaseDistribution/importNoticeEdit'
  }
},
{
  path: '/purchaseDistribution/importNoticeRead',
  name: 'importNoticeRead',
  component: () => import('./views/purchaseDistribution/importNoticeRead'),
  meta: {
      title: 'importNoticeCommon.h4',
      tagsView: '/purchaseDistribution/importNoticeRead',
      authority: '/purchaseDistribution/importNoticeRead'
  }
},
{
    path: '/purchaseDistribution/enameledWireMateBarView',
    name: 'enameledWireMateBarView',
    component: () => import('./views/purchaseDistribution/enameledWireMateBarView'),
    meta: {
        title: 'route.enameledWireMateBarView',
        tagsView: '/purchaseDistribution/enameledWireMateBarView',
        authority: '/purchaseDistribution/enameledWireMateBarView'
    }
  },
  {
    path: '/purchaseDistribution/enameledWireMateBarBind',
    name: 'enameledWireMateBarBind',
    component: () => import('./views/purchaseDistribution/enameledWireMateBarBind'),
    meta: {
        title: 'route.enameledWireMateBarBind',
        tagsView: '/purchaseDistribution/enameledWireMateBarBind',
        authority: '/purchaseDistribution/enameledWireMateBarBind'
    }
  },
  {
    path: '/qualityManagement/IncomingMaterialInspection',
    name: 'IncomingMaterialInspection',
    component: () => import('./views/qualityManagement/PDCA'),
    meta: {
        title: 'route.pdca',
        tagsView: '/qualityManagement/IncomingMaterialInspection',
        authority: '/qualityManagement/IncomingMaterialInspection'
    }
},
{
    path: '/qualityManagement/IncomingProcess',
    name: 'IncomingProcess',
    component: () => import('./views/qualityManagement/IncomingProcess'),
    meta: {
        title: 'route.pdca',
        tagsView: '/qualityManagement/IncomingProcess',
        authority: '/qualityManagement/IncomingProcess'
    }
},
{
    path: '/qualityManagement/firstInspectionQueryList',
    name: 'firstInspectionQueryList',
    component: () => import('./views/qualityManagement/firstInspectionQuery/firstInspectionQueryList'),
    meta: {
        title: 'route.firstInspectionQueryList',// 首检报告维护
        tagsView: '/qualityManagement/firstInspectionQueryList',
        authority: '/qualityManagement/firstInspectionQueryList'
    }
},
{
    path: '/qualityManagement/firstInspectionQueryAdd',
    name: 'firstInspectionQueryAdd',
    component: () => import('./views/qualityManagement/firstInspectionQuery/firstInspectionQueryAdd'),
    meta: {
        title: 'route.firstInspectionQueryAdd',// 首检新增
        tagsView: '/qualityManagement/firstInspectionQueryAdd',
        authority: '/qualityManagement/firstInspectionQueryAdd'
    }
},
{
    path: '/qualityManagement/shipmentInspectionAdd',
    name: 'shipmentInspectionAdd',
    component: () => import('./views/qualityManagement/firstInspectionQuery/shipmentInspectionAdd'),
    meta: {
        title: 'route.shipmentInspectionAdd', // 首检报告新增
        tagsView: '/qualityManagement/shipmentInspectionAdd',
        authority: '/qualityManagement/shipmentInspectionAdd'
    }
},
{
    path: '/qualityManagement/shipmentInspectionRead',
    name: 'shipmentInspectionRead',
    component: () => import('./views/qualityManagement/firstInspectionQuery/shipmentInspectionAdd'),
    meta: {
        title: 'route.shipmentInspectionRead', // 首检报告查看
        tagsView: '/qualityManagement/shipmentInspectionRead',
        authority: '/qualityManagement/shipmentInspectionRead'
    }
},
{
    path: '/subAccountManagement',
    name: 'subAccountManagement',
    component: () => import('./views/supplier/subAccountManagement'),
    meta: {
        title: 'route.subAccountManagement',
        tagsView: '/subAccountManagement',
        authority: '/subAccountManagement'
    } 
},
{
    path: '/qualityManagement/viewShipmentInspection',
    name: 'viewShipmentInspection',
    component: () => import('./views/qualityManagement/viewShipmentInspection'),
    meta: {
        title: 'route.pdca',
        tagsView: '/qualityManagement/viewShipmentInspection',
        authority: '/qualityManagement/viewShipmentInspection'
    }
},
{
    path: '/qualityManagement/ViewIncomingProcess',
    name: 'ViewIncomingProcess',
    component: () => import('./views/qualityManagement/ViewIncomingProcess'),
    meta: {
        title: 'route.pdca',
        tagsView: '/qualityManagement/ViewIncomingProcess',
        authority: '/qualityManagement/ViewIncomingProcess'
    }
},
{
    path: '/purchaseDistribution/invoiceMonitoring',
    name: 'invoiceMonitoring',
    component: () => import('./views/purchaseDistribution/invoiceMonitoring'),
    meta: {
        title: 'DeliveryOrderQuery.t58',
        tagsView: '/purchaseDistribution/invoiceMonitoring',
        authority: '/purchaseDistribution/invoiceMonitoring'
    }
},
{
    path: '/qualityManagement/HSInspectManageMaterial',
    name: 'HSInspectManageMaterial',
    component: () => import('./views/qualityManagement/HSInspectManageMaterial'),
    meta: {
        title: 'route.HSInspectManageMaterial',
        tagsView: '/qualityManagement/HSInspectManageMaterial',
        authority: '/qualityManagement/HSInspectManageMaterial'
    }
},
{
    path: '/qualityManagement/HSInspectManageMaterialDetail',
    name: 'HSInspectManageMaterialDetail',
    component: () => import('./views/qualityManagement/HSInspectManageMaterialDetail'),
    meta: {
        title: 'route.HSInspectManageMaterialDetail',
        tagsView: '/qualityManagement/HSInspectManageMaterialDetail',
        authority: '/qualityManagement/HSInspectManageMaterialDetail'
    }
},
{
    path: '/financialAccounting/fpzPenalty',
    name: 'fpzPenalty',
    component: () => import('./views/financialAccounting/fpzPenalty'),
    meta: {
        title: 'route.fpzPenalty',
        tagsView: '/financialAccounting/fpzPenalty',
        authority: '/financialAccounting/fpzPenalty'
    }
},
{
  path: '/qualityManagement/groupStop',
  name: 'groupStop',
  component: () => import('./views/qualityManagement/groupStop'),
  meta: {
      title: 'route.groupStop',
      tagsView: '/qualityManagement/groupStop',
      authority: '/qualityManagement/groupStop'
  }
},
{
    path: '/financialAccounting/intercourseReconciliationsSearch',
    name: 'intercourseReconciliationsSearch',
    component: () => import('./views/financialAccounting/intercourseReconciliationsSearch'),
    meta: {
        title: 'route.intercourseReconciliationsSearch',
        tagsView: '/financialAccounting/intercourseReconciliationsSearch',
        authority: '/financialAccounting/intercourseReconciliationsSearch'
    }
},
{
    path: '/financialAccounting/intercourseReconciliationsAdd',
    name: 'intercourseReconciliationsAdd',
    component: () => import('./views/financialAccounting/intercourseReconciliationsAdd'),
    meta: {
        title: 'route.intercourseReconciliationsAdd',
        tagsView: '/financialAccounting/intercourseReconciliationsAdd',
        authority: '/financialAccounting/intercourseReconciliationsAdd'
    }
},
{
  path: '/qualityManagement/typeTestProcessSearch',
  name: 'typeTestProcessSearch',
  component: () => import('./views/qualityManagement/typeTestProcessSearch'),
  meta: {
      title: 'route.typeTestProcessSearch',
      tagsView: '/qualityManagement/typeTestProcessSearch',
      authority: '/qualityManagement/typeTestProcessSearch'
  }
},
{
  path: '/qualityManagement/typeTestProcessList',
  name: 'typeTestProcessList',
  component: () => import('./views/qualityManagement/typeTestProcessList'),
  meta: {
      title: 'route.typeTestProcessList',
      tagsView: '/qualityManagement/typeTestProcessList',
      authority: '/qualityManagement/typeTestProcessList'
  }
},
{
    path: '/qualityManagement/vendorBadRecord',
    name: 'vendorBadRecord',
    component: () => import('./views/qualityManagement/vendorBadRecord'),
    meta: {
        title: 'route.vendorBadRecord',
        tagsView: '/qualityManagement/vendorBadRecord',
        authority: '/qualityManagement/vendorBadRecord'
    }
},
{
    path: '/qualityManagement/itemBadRecord',
    name: 'itemBadRecord',
    component: () => import('./views/qualityManagement/itemBadRecord'),
    meta: {
        title: 'route.itemBadRecord',
        tagsView: '/qualityManagement/itemBadRecord',
        authority: '/qualityManagement/itemBadRecord'
    }
},
{
    path: '/qualityManagement/incomingInspection',
    name: 'incomingInspection',
    component: () => import('./views/qualityManagement/incomingInspection'),
    meta: {
        title: 'route.incomingInspection',
        tagsView: '/qualityManagement/incomingInspection',
        authority: '/qualityManagement/incomingInspection'
    }
},
{
    path: '/qualityManagement/reworkProcess',
    name: 'reworkProcess',
    component: () => import('./views/qualityManagement/reworkProcess'),
    meta: {
        title: 'route.reworkProcess',
        tagsView: '/qualityManagement/reworkProcess',
        authority: '/qualityManagement/reworkProcess'
    }
},
{
    path: '/qualityManagement/reworkProcessDetail',
    name: 'reworkProcessDetail',
    component: () => import('./views/qualityManagement/reworkProcessDetail'),
    meta: {
        title: 'route.reworkProcessDetail',
        tagsView: '/qualityManagement/reworkProcessDetail',
        authority: '/qualityManagement/reworkProcessDetail'
    }
},
{
    path: '/financialAccounting/fpzInvaccSearch',
    name: 'fpzInvaccSearch',
    component: () => import('./views/financialAccounting/fpzInvaccSearch'),
    meta: {
        title: 'route.fpzInvaccSearch',
        tagsView: '/financialAccounting/fpzInvaccSearch',
        authority: '/financialAccounting/fpzInvaccSearch'
    }
},
{
    path: '/financialAccounting/fpzInvaccAdd',
    name: 'fpzInvaccAdd',
    component: () => import('./views/financialAccounting/fpzInvaccAdd'),
    meta: {
        title: 'route.fpzInvaccAdd',
        tagsView: '/financialAccounting/fpzInvaccAdd',
        authority: '/financialAccounting/fpzInvaccAdd'
    }
},
{
    path: '/financialAccounting/fpzInvaccDetail',
    name: 'fpzInvaccDetail',
    component: () => import('./views/financialAccounting/fpzInvaccDetail'),
    meta: {
        title: 'route.fpzInvaccDetail',
        tagsView: '/financialAccounting/fpzInvaccDetail',
        authority: '/financialAccounting/fpzInvaccDetail'
    }
},
{
    path: '/financialAccounting/fpzLiabilitySearch',
    name: 'fpzLiabilitySearch',
    component: () => import('./views/financialAccounting/fpzLiabilitySearch'),
    meta: {
        title: 'route.fpzLiabilitySearch',
        tagsView: '/financialAccounting/fpzLiabilitySearch',
        authority: '/financialAccounting/fpzLiabilitySearch'
    }
},
{
    path: '/financialAccounting/fpzLiabilityAdd',
    name: 'fpzLiabilityAdd',
    component: () => import('./views/financialAccounting/fpzLiabilityAdd'),
    meta: {
        title: 'route.fpzLiabilityAdd',
        tagsView: '/financialAccounting/fpzLiabilityAdd',
        authority: '/financialAccounting/fpzLiabilityAdd'
    }
},
{
    path: '/financialAccounting/fpzliabilityDetail',
    name: 'fpzliabilityDetail',
    component: () => import('./views/financialAccounting/fpzliabilityDetail'),
    meta: {
        title: 'route.fpzliabilityDetail',
        tagsView: '/financialAccounting/fpzliabilityDetail',
        authority: '/financialAccounting/fpzliabilityDetail'
    }
},
{
    path: '/financialAccounting/reconciliantMaintenance',
    name: 'reconciliantMaintenance',
    component: () => import('./views/financialAccounting/reconciliantMaintenance'),
    meta: {
        title: 'route.reconciliantMaintenance',
        tagsView: '/financialAccounting/reconciliantMaintenance',
        authority: '/financialAccounting/reconciliantMaintenance'
    }
},
{
    path: '/financialAccounting/gscInvoice',
    name: 'gscInvoice',
    component: () => import('./views/financialAccounting/gscInvoice'),
    meta: {
        title: 'route.gscInvoice',
        tagsView: '/financialAccounting/gscInvoice',
        authority: '/financialAccounting/gscInvoice'
    }
},
{
    path: '/financialAccounting/gscInvoiceAdd',
    name: 'gscInvoiceAdd',
    component: () => import('./views/financialAccounting/gscInvoiceAdd'),
    meta: {
        title: 'route.gscInvoiceAdd',
        tagsView: '/financialAccounting/gscInvoiceAdd',
        authority: '/financialAccounting/gscInvoiceAdd'
    }
},
{
    path: '/financialAccounting/gscInvoiceEdit',
    name: 'gscInvoiceEdit',
    component: () => import('./views/financialAccounting/gscInvoiceEdit'),
    meta: {
        title: 'route.gscInvoiceDetail',
        tagsView: '/financialAccounting/gscInvoiceEdit',
        authority: '/financialAccounting/gscInvoiceEdit'
    }
},
{
    path: '/financialAccounting/gscInvoiceDetail',
    name: 'gscInvoiceDetail',
    component: () => import('./views/financialAccounting/gscInvoiceDetail'),
    meta: {
        title: 'route.gscInvoiceDetail',
        tagsView: '/financialAccounting/gscInvoiceDetail',
        authority: '/financialAccounting/gscInvoiceDetail'
    }
},
{
    path: '/financialAccounting/taxControlInvoice',
    name: 'taxControlInvoice',
    component: () => import('./views/financialAccounting/taxControlInvoice'),
    meta: {
        title: 'route.taxControlInvoice',
        tagsView: '/financialAccounting/taxControlInvoice',
        authority: '/financialAccounting/taxControlInvoice'
    }
},
{
    path: '/financialAccounting/noPriceDetails', // 无开票价格明细
    name: 'noPriceDetails',
    component: () => import('./views/financialAccounting/noPriceDetails'),
    meta: {
        title: 'route.noPriceDetails',
        tagsView: '/financialAccounting/noPriceDetails',
        authority: '/financialAccounting/noPriceDetails',
    },
},
{
    path: '/qualityManagement/processInspectionSearch', // 过程检验查询
    name: 'processInspectionSearch',
    component: () => import('./views/qualityManagement/processInspectionSearch'),
    meta: {
        title: 'route.processInspectionSearch',
        tagsView: '/qualityManagement/processInspectionSearch',
        authority: '/qualityManagement/processInspectionSearch'
    }
},
{
    path: '/qualityManagement/processInspectionEdit', // 过程检验维护
    name: 'processInspectionEdit',
    component: () => import('./views/qualityManagement/processInspectionEdit'),
    meta: {
        title: 'route.processInspectionEdit',
        tagsView: '/qualityManagement/processInspectionEdit',
        authority: '/qualityManagement/processInspectionEdit'
    }
},
{
    path: '/qualityManagement/processInspectionRead', // 过程检验查看
    name: 'processInspectionRead',
    component: () => import('./views/qualityManagement/processInspectionRead'),
    meta: {
        title: 'route.processInspectionRead',
        tagsView: '/qualityManagement/processInspectionRead',
        authority: '/qualityManagement/processInspectionRead'
    }
},
{
    path: '/qualityManagement/processInspectionAdd', // 过程检验新增
    name: 'processInspectionAdd',
    component: () => import('./views/qualityManagement/processInspectionAdd'),
    meta: {
        title: 'route.processInspectionAdd',
        tagsView: '/qualityManagement/processInspectionAdd',
        authority: '/qualityManagement/processInspectionAdd'
    }
},
{
    path: '/qualityManagement/processInspectionMatch', // 匹配检验报告
    name: 'processInspectionMatch',
    component: () => import('./views/qualityManagement/processInspectionMatch'),
    meta: {
        title: 'route.processInspectionMatch',
        tagsView: '/qualityManagement/processInspectionMatch',
        authority: '/qualityManagement/processInspectionMatch',
    },
},
{
    path: '/financialAccounting/fpzPay', // 海外付款计划查询
    name: 'fpzPay',
    component: () => import('./views/financialAccounting/fpzPay'),
    meta: {
        title: 'route.fpzPay',
        tagsView: '/financialAccounting/fpzPay',
        authority: '/financialAccounting/fpzPay',
    },
},
{
    path: '/wonderful8/:system/:routerLink', // 现场评审
    name: 'wonderful8',
    props: true,
    component: () => import('./views/UrlInstanceRender'),
    meta: {
        title: 'menu.t8'
    }
},
{
    path: '/purchaseDistribution/UIDLabelPrint', // 海外UID标签
    name: 'UIDLabelPrint',
    component: () => import('./views/purchaseDistribution/UIDLabelPrint'),
    meta: {
        title: 'route.UIDLabelPrint',
        tagsView: '/purchaseDistribution/UIDLabelPrint',
        authority: '/purchaseDistribution/UIDLabelPrint',
    },
},
{
    path: '/purchaseDistribution/UIDLabelPrintHistory', // 补打标签
    name: 'UIDLabelPrintHistory',
    component: () => import('./views/purchaseDistribution/UIDLabelPrintHistory'),
    meta: {
        title: 'route.UIDLabelPrintHistory',
        tagsView: '/purchaseDistribution/UIDLabelPrintHistory',
        authority: '/purchaseDistribution/UIDLabelPrintHistory',
    },
},
{
    path: '/purchaseDistribution/supplierEcConfirm', // 海外EC变更确认
    name: 'supplierEcConfirm',
    component: () => import('./views/purchaseDistribution/supplierEcConfirm'),
    meta: {
        title: 'route.supplierEcConfirm',
        tagsView: '/purchaseDistribution/supplierEcConfirm',
        authority: '/purchaseDistribution/supplierEcConfirm',
    },
},
{
  path: '/auth/menuManage',
  name: 'menuManage',
  component: () => import('./views/auth/menuManage'),
  meta: {
      title: '菜单管理',
      tagsView: '/auth/menuManage',
      authority: '/auth/menuManage'
  }
},
{
  path: '/auth/roleManage',
  name: 'roleManage',
  component: () => import('./views/auth/roleManage'),
  meta: {
      title: '角色管理',
      tagsView: '/auth/roleManage',
      authority: '/auth/roleManage'
  }
},
{
  path: '/auth/roleAuthority',
  name: 'roleAuthority',
  component: () => import('./views/auth/roleAuthority'),
  meta: {
      title: '用户角色权限',
      tagsView: '/auth/roleAuthority',
      authority: '/auth/roleAuthority'
  }
},
{
    path: '/purchaseDistribution/TMRollingForecast', // 三月滚动
    name: 'TMRollingForecast',
    component: () => import('./views/purchaseDistribution/TMRollingForecast'),
    meta: {
        title: 'route.TMRollingForecast',
        tagsView: '/purchaseDistribution/TMRollingForecast',
        authority: '/purchaseDistribution/TMRollingForecast',
    },
},
{
    path: '/sys/switchingOperations',
    name: 'switchingOperations',
    component: () => import('./views/sys/switchingOperations'),
    meta: {
        title: '运维切换',
        tagsView: '/sys/switchingOperations',
        authority: '/sys/switchingOperations',
    },
},
{
    path: '/interface/interfaceSynchronize',
    name: 'interfaceSynchronize',
    component: () => import('./views/interface/interfaceSynchronize'),
    meta: {
        title: '接口同步',
        tagsView: '/interface/interfaceSynchronize',
        authority: '/interface/interfaceSynchronize',
    },
},
{
    path: '/announcement/announcementList',
    name: 'announcementList',
    component: () => import('./views/announcement/announcementList'),
    meta: {
        title: '海外弹窗公告',
        tagsView: '/announcement/announcementList',
        authority: '/announcement/announcementList',
    },
},
{
    path: '/announcement/announcementAdd',
    name: 'announcementAdd',
    component: () => import('./views/announcement/announcementAdd'),
    meta: {
        title: '海外弹窗公告新增',
        tagsView: '/announcement/announcementAdd',
        authority: '/announcement/announcementAdd',
    },
},
{
    path: '/announcement/announcementEdit',
    name: 'announcementEdit',
    component: () => import('./views/announcement/announcementEdit'),
    meta: {
        title: '海外弹窗公告编辑',
        tagsView: '/announcement/announcementEdit',
        authority: '/announcement/announcementEdit',
    },
},
{
    path: '/purchaseDistribution/suppliesFormOutside', // 外协请领
    name: 'suppliesFormOutside',
    component: () => import('./views/purchaseDistribution/suppliesFormOutside'),
    meta: {
        title: 'route.suppliesFormOutside',
        tagsView: '/purchaseDistribution/suppliesFormOutside',
        authority: '/purchaseDistribution/suppliesFormOutside',
    },
},
{
    path: '/purchaseDistribution/suppliesFormOutsideAdd', // 新增请领单
    name: 'suppliesFormOutsideAdd',
    component: () => import('./views/purchaseDistribution/suppliesFormOutsideAdd'),
    meta: {
        title: 'suppliesFormOutside.t10',
        tagsView: '/purchaseDistribution/suppliesFormOutsideAdd',
        authority: '/purchaseDistribution/suppliesFormOutsideAdd',
    },
},
{
    path: '/purchaseDistribution/suppliesFormOutsideEdit', // 请领单修改
    name: 'suppliesFormOutsideEdit',
    component: () => import('./views/purchaseDistribution/suppliesFormOutsideEdit'),
    meta: {
        title: 'suppliesFormOutside.t10',
        tagsView: '/purchaseDistribution/suppliesFormOutsideEdit',
        authority: '/purchaseDistribution/suppliesFormOutsideEdit',
    },
},
{
    path: '/purchaseDistribution/suppliesFormOutsideDetail', // 请领单详情
    name: 'suppliesFormOutsideDetail',
    component: () => import('./views/purchaseDistribution/suppliesFormOutsideDetail'),
    meta: {
        title: 'suppliesFormOutside.t12',
        tagsView: '/purchaseDistribution/suppliesFormOutsideDetail',
        authority: '/purchaseDistribution/suppliesFormOutsideDetail',
    },
},
{
    path: '/purchaseDistribution/wxBomQuery', // 外协BOM查询
    name: 'wxBomQuery',
    component: () => import('./views/purchaseDistribution/wxBomQuery'),
    meta: {
        title: 'route.wxBomQuery',
        tagsView: '/purchaseDistribution/wxBomQuery',
        authority: '/purchaseDistribution/wxBomQuery',
    },
},
{
    path: '/purchaseDistribution/commercialInvoice', // 商业发票
    name: 'commercialInvoice',
    component: () => import('./views/purchaseDistribution/commercialInvoice/index.vue'),
    meta: {
        title: 'route.commercialInvoice',
        tagsView: '/purchaseDistribution/commercialInvoice',
        authority: '/purchaseDistribution/commercialInvoice',
    },
},
{
    path: '/purchaseDistribution/commercialInvoiceAdd', // 商业发票新增
    name: 'commercialInvoiceAdd',
    component: () => import('./views/purchaseDistribution/commercialInvoice/add.vue'),
    meta: {
        title: 'route.commercialInvoiceAdd',
        tagsView: '/purchaseDistribution/commercialInvoiceAdd',
        authority: '/purchaseDistribution/commercialInvoiceAdd',
    },
},
{
    path: '/purchaseDistribution/commercialInvoiceEdit', // 商业发票编辑
    name: 'commercialInvoiceEdit',
    component: () => import('./views/purchaseDistribution/commercialInvoice/edit.vue'),
    meta: {
        title: 'route.commercialInvoiceEdit',
        tagsView: '/purchaseDistribution/commercialInvoiceEdit',
        authority: '/purchaseDistribution/commercialInvoiceEdit',
    },
},
{
    path: '/purchaseDistribution/commercialInvoiceDetail', // 商业发票详情
    name: 'commercialInvoiceDetail',
    component: () => import('./views/purchaseDistribution/commercialInvoice/detail.vue'),
    meta: {
        title: 'route.commercialInvoiceDetail',
        tagsView: '/purchaseDistribution/commercialInvoiceDetail',
        authority: '/purchaseDistribution/commercialInvoiceDetail',
    },
},
{
    path: '/sys/param/Param',
    name: '字典维护',
    component: () => import('./views/sys/wordBook.vue'),
    meta: {
        title: '字典维护',
        tagsView: '/sys/param/Param',
        authority: '/sys/param/Param',
    },
},
{
    path: '/sys/gscSysOrganizationsQueryView',
    name: '组织设置',
    component: () => import('./views/sys/GscSysOrganizationsQueryView.vue'),
    meta: {
        title: '组织设置',
        tagsView: '/sys/gscSysOrganizationsQueryView',
        authority: '/sys/GscSysOrganizationsQueryView',
    },
},
...plmRoutes
]
},
{
path: '*',
name: '404',
component: () => import('@/components/core/core_page/404.vue')
}
];
export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: routeConfig,
});
